{
  "title": "Daily training",
  "trainToday": "Train today",
  "runDayNow": "Run today's training now",
  "dayClose": {
    "waiting": "Today's training runs on its own once the last race is done, from {hour}:00.",
    "ready": "Today's training is ready. Run it now, or let it run on its own."
  },
  "trainNow": {
    "button": "Train now",
    "running": "Running…",
    "helper": "Locks today's training and today's race selection. The result is the same as if you wait.",
    "helperRace": "Locks today's training and today's race selection ({race}). The result is the same as if you wait.",
    "locked": "Today's training and entries are locked. Fatigue and form update at the evening settlement.",
    "afterRace": "Riders racing today are settled after their stage.",
    "pressResult": "{trained, plural, one {# rider trained now} other {# riders trained now}}, {waiting, plural, one {# waiting for his race} other {# waiting for their race}}.",
    "pressResultAll": "{trained, plural, one {# rider trained now.} other {# riders trained now.}}",
    "settled": "Today's training is settled.",
    "previousOpen": "Yesterday's training is still being settled. Try again in a moment.",
    "noRaceDay": "There is no race day today, so there is nothing to lock.",
    "error": "Today could not be locked. Try again.",
    "planLocked": "Today's fields are locked. You can still change tomorrow.",
    "shortRace": "{race}: only {fit} of {min} fit riders selected. After Train now no rider can be added, so your team will not start.",
    "shortRaceEmpty": "{race}: no riders selected. After Train now the assistant cannot pick any, so your team will not start.",
    "shortRaceStarts": "{race}: only {fit} of {min} fit riders selected. After Train now no rider can be added, so your team starts with {fit}.",
    "confirm": {
      "title": "Your team will not start",
      "titleShort": "Your team starts with fewer riders",
      "go": "Train anyway",
      "cancel": "Cancel"
    }
  },
  "trainedToday_you": "Trained today (by you)",
  "trainedToday_assistant": "Trained today (by assistant)",
  "trainedTodayAt_you": "Trained today at {time} (by you)",
  "trainedTodayAt_assistant": "Trained today at {time} (by assistant)",
  "notTrainedYetToday": "Not trained yet today",
  "tickModelDone": "Today's training has already run. Changes to focus or intensity now take effect at the next training (tomorrow). Form and fatigue update only at the daily training, not continuously.",
  "disabledNote": "Daily training is currently paused. Training programs can still be set up now.",
  "form": "Form",
  "fatigue": "Fatigue",
  "mobileSort": {
    "label": "Sort by",
    "ascAria": "Sorting ascending, tap for descending",
    "descAria": "Sorting descending, tap for ascending"
  },
  "tabs": {
    "today": "Today",
    "weekplan": "Week plan",
    "development": "Development",
    "history": "History",
    "report": "Report",
    "program": "Program"
  },
  "primary": {
    "setDays": "Set days for {n, plural, one {# rider} other {# riders}}"
  },
  "decision": {
    "title": "Today's decision",
    "recovery": "active recovery today",
    "reason": "Fatigue {fatigue} with a hard day planned. Injury risk is raised.",
    "use": "Use",
    "useAria": "Set {name} to active recovery",
    "useAll": "Use all {n} suggestions",
    "none": "No rider needs a change today.",
    "failed": "Could not save. Try again.",
    "segLabel": "Filter riders",
    "segAll": "All {n}",
    "segTraining": "Training {n}",
    "segRacing": "Racing {n}",
    "segTired": "Fatigue {from}+ {n}",
    "colDays70": "Days {from}+",
    "days70Hint": "Settled days in a row at fatigue {from} or more",
    "colAssistant": "Assistant",
    "assistantRecovery": "Active recovery",
    "agrees": "Agrees",
    "raceChip": "Race"
  },
  "overview": {
    "label": "Today at a glance",
    "needsDay": "Needs a day",
    "racing": "Racing today",
    "training": "Training today",
    "tired": "Tired · fatigue {from}+",
    "needsDayShort": "Needs a day",
    "racingShort": "Racing",
    "trainingShort": "Training",
    "tiredShort": "Tired",
    "restRecovery": "{rest} rest · {recovery} recovery",
    "more": "+{n} more",
    "filterAria": "Show only: {label}",
    "status": "Today's training",
    "statusPaused": "Paused",
    "statusNotYet": "Not run yet",
    "statusWaiting": "Runs on its own from {hour}:00",
    "statusRunning": "Running, auto-updates",
    "statusReady": "Ready to run",
    "runNow": "Run now",
    "showing": "Showing: {label}",
    "showAll": "Show all",
    "emptyFiltered": "No riders here right now.",
    "changesTomorrow": "Changes now take effect tomorrow."
  },
  "today": {
    "colSelect": "Select",
    "colDay": "Today's day",
    "colSeasonPoints": "Season pts",
    "colFatigueTonight": "Fatigue now / tonight",
    "fatigueTonightAria": "Fatigue now {now}, tonight approx. {value}. {band}",
    "selectRider": "Select {name}",
    "applyTo": "Apply to {n}",
    "bulkLead": "Set today's day for",
    "bulkScopeAll": "All {n, plural, one {# rider} other {# riders}}",
    "bulkTo": "to",
    "bulkApply": "Apply",
    "bulkHint": "Tick riders to set it for just them.",
    "setForGroup": "Set for group",
    "raceDaysHint": "What the rider does on each of today's race days.",
    "clear": "Clear",
    "noDaySet": "No day set yet",
    "useAssistantPick": "Use assistant pick: {session}",
    "count": "{n, plural, one {# rider} other {# riders}}"
  },
  "daySelect": {
    "placeholder": "Set day",
    "saved": "Saved",
    "aria": "Today's day for {name}"
  },
  "resetProgram": {
    "action": "Back to team program",
    "done": "Back on team program",
    "error": "Could not reset. Try again in a moment."
  },
  "card": {
    "changeDay": "Change day",
    "profile": "Rider profile",
    "weekPlan": "Week plan",
    "followsTeam": "Follows the team plan",
    "ownPlan": "Has his own plan",
    "giveOwnPlan": "Give him his own plan",
    "editOwnPlan": "Edit his plan"
  },
  "weekPlan": {
    "title": "Week plan",
    "planFor": "Plan for",
    "team": "Team · {n, plural, one {# rider} other {# riders}}",
    "teamIntro": "Set the intensity for each day of the week.",
    "colDay": "Day",
    "colWholeDay": "Whole day",
    "today": "Today",
    "save": "Save plan",
    "undo": "Undo changes",
    "unsaved": "{n, plural, one {# change not saved} other {# changes not saved}}",
    "ownPlansEmpty": "No rider has his own plan yet. Pick a rider under Plan for to give him one.",
    "ownPlansChips": "Riders with own plan:",
    "ownPlansMore": "+{n}",
    "copySource": "Copy day",
    "copyCount": "Days to copy to",
    "copyOption": "{n, plural, one {Next day} other {Next # days}}",
    "copyButton": "Copy",
    "copyDone": "{n, plural, one {Copied to # day. Save to keep it.} other {Copied to # days. Save to keep it.}}",
    "copyNone": "No open days to copy to."
  },
  "howTrainingWorksLink": "How training works",
  "development": {
    "colDevelopment": "Development",
    "ageLine": "Age {age}",
    "ageRoleLine": "Age {age} · {role}",
    "numbers": "{now} · {lo}-{hi} · ceiling {loft}",
    "numbersNoLoft": "{now} · {lo}-{hi}",
    "noForecastYet": "No forecast yet"
  },
  "injuryRisk": "High injury risk",
  "injured": "Injured: {days} day left",
  "injured_plural": "Injured: {days} days left",
  "injuredRaceDays": "Injured: {days, plural, one {1 race day} other {# race days}} left (approx. {date})",
  "injuredRaceDaysPlain": "Injured: {days, plural, one {1 race day} other {# race days}} left",
  "injuredApprox": "Back approx. {date}",
  "noRiders": "No riders on your squad yet.",
  "report": "Today's training report",
  "bonusApplied": "Trained by you",
  "gains": "+{n} {ability}",
  "gainJump": "{from} → {to} {ability}",
  "noGains": "No gains today",
  "noFocus": "No focus set",
  "restDay": "Rest day",
  "toGo": "{pct}% to next +1 in {ability}",
  "sharpDay": "Sharp day",
  "flatDay": "Flat day",
  "fatigueChange": "{delta} fatigue",
  "summaryTrained": "Riders trained",
  "summaryBreakthroughs": "Breakthroughs",
  "summaryPeakForm": "In peak form",
  "loading": "Loading…",
  "colRider": "Rider",
  "colType": "Type",
  "colAge": "Age",
  "colNextUp": "Next +1",
  "colGains": "Gains",
  "colResult": "Result",
  "colScore": "Score",
  "colStatus": "Status",
  "colWeekPlan": "Weekly plan",
  "groupByType": "Group by type",
  "untypedGroup": "No type yet",
  "groupCount": "{n, plural, one {# rider} other {# riders}}",
  "selectAll": "Select all",
  "selected": "{n, plural, one {# selected} other {# selected}}",
  "bulkSetFocus": "Set focus for selected",
  "bulkIntensity": "Intensity",
  "bulkApply": "Apply to {n} selected",
  "bulkApplying": "Applying…",
  "bulkClear": "Clear selection",
  "bulkApplied": "{n, plural, one {Updated # rider.} other {Updated # riders.}}",
  "bulkPartial": "Updated {applied} of {total}. {failed} could not be saved. Try again in a moment.",
  "bulkPickFocus": "Pick a focus to apply.",
  "smartFocusHint": "Assistant: {focus} (auto)",
  "bulkSmartFocusOption": "Smart focus (by rider type)",
  "bulkSmartSkippedHasPlan": "{n, plural, one {Skipped # rider with an existing plan.} other {Skipped # riders with an existing plan.}}",
  "assistantSuggestions": {
    "openButton": "Get suggestions from the assistant",
    "title": "Assistant suggestions",
    "intro": "The assistant suggests a training focus for your riders. Review them below, then accept all or only the ones you want.",
    "onlyNoPlanToggle": "Only riders without a plan ({n})",
    "selectRow": "Select rider",
    "noPlanMarker": "No plan",
    "yourPlanMarker": "Your plan",
    "suggestionLine": "Suggests: {session}, {intensity}",
    "acceptSelected": "Accept selected ({n})",
    "acceptAll": "Accept all ({n})",
    "allHavePlanNote": "Every rider shown already has your own plan, and the assistant never changes those. Clear a rider's focus to let it take over.",
    "dismiss": "Dismiss",
    "nothingAppliedYet": "Nothing is applied until you accept.",
    "empty": "No suggestions right now. Every rider already has a matched focus.",
    "emptyFiltered": "Every rider already has a plan.",
    "chooseByRider": "Choose rider by rider ({n})",
    "programTitle": "Programs for your groups",
    "programIntro": "A ready-made week for each type of rider. It only goes to riders without their own plan.",
    "programFor": "{type}: {count, plural, one {# rider} other {# riders}}",
    "programApply": "Apply to these {n}",
    "programApplied": "Program applied to {n, plural, one {# rider} other {# riders}}.",
    "programSkipped": "{n, plural, one {Skipped # rider with their own plan.} other {Skipped # riders with their own plan.}}"
  },
  "historyTitle": "Training history",
  "historySubtitle": "Your last 30 days of daily training",
  "historyEmpty": "No training runs yet. Once daily training is live, each day's run will be logged here.",
  "historyByYou": "By you",
  "historyByAssistant": "By assistant",
  "historyDaySummary": "{trained} trained · {breakthroughs} breakthroughs · {peakForm} in peak form",
  "historyToggleOpen": "Show riders",
  "historyToggleClose": "Hide riders",
  "riderHistoryTitle": "Training history",
  "riderHistorySubtitle": "This rider's daily training over the last 30 days",
  "riderHistoryEmpty": "No training history for this rider yet.",
  "riderHistoryRest": "Rest day",
  "weekday_mon": "Mon",
  "weekday_tue": "Tue",
  "weekday_wed": "Wed",
  "weekday_thu": "Thu",
  "weekday_fri": "Fri",
  "weekday_sat": "Sat",
  "weekday_sun": "Sun",
  "weekRhythmResetButton": "Reset to no rhythm",
  "weekRhythmSaved": "Weekly rhythm saved.",
  "weekRhythmReset": "Weekly rhythm removed: riders are back to their season intensity every day.",
  "weekRhythmSaveFailed": "Could not save. Try again in a moment.",
  "planActionErrorGeneric": "Could not save. Try again in a moment.",
  "planActionError_train_now_locked": "Today's fields are locked. You can still change tomorrow.",
  "planActionError_no_slots": "No training slots left.",
  "planActionError_not_own_rider": "You can only train your own riders.",
  "planActionError_auth": "Your session expired. Sign in again.",
  "planActionError_network": "Connection failed. Check your network and try again.",
  "weekRhythmTodayShort": "Today: {intensity}",
  "weekRhythmTodayHint": "today: {intensity} (team weekly rhythm)",
  "weekRhythmTodayHintOwn": "today: {intensity} (own weekly plan)",
  "weekRhythmTodayHintPlan": "today: {intensity} (this rider's own setting, overrides team rhythm)",
  "raceDayBadge": "Race day",
  "raceDayTooltip": "{riderName} rides {raceName} today. The race replaces the planned session and develops the abilities the race demands. Your plan is unchanged and applies again tomorrow.",
  "raceDayTooltipRaceFallback": "a race",
  "receipt": {
    "title": "This season",
    "colAbility": "Ability",
    "colNow": "Now",
    "colSeason": "Season",
    "colProgress": "Progress",
    "nowTooltip": "The rider's current value, not the ceiling. Check the bar or the \"done\" tag to see if there's more to gain.",
    "done": "done",
    "doneTitle": "This ability is fully developed. Training develops this rider's other abilities instead.",
    "inFocusTitle": "Trained by the current focus.",
    "since": "Since {date}",
    "startsOn": "Starts {date}",
    "note": "Whole points gained since the season started. A gold dot marks the abilities the current focus trains.",
    "pending": "Season totals appear once the active season is loaded.",
    "notStarted": "The season starts {date}. Season totals begin then, and training before that still counts toward the next point.",
    "noDaysYet": "No training days in this season yet. Season totals start after the first day of training, and every point already earned stays in the bars.",
    "yesterdayContribution": "{pct}% of this bar came from yesterday's session.",
    "yesterdayGain": "yesterday +{pct}%",
    "todayGain": "today +{pct}%",
    "datedGain": "{date} +{pct}%",
    "todayContribution": "{pct}% of this bar came from today's session.",
    "datedContribution": "{pct}% of this bar came from the session on {date}."
  },
  "gainedToday": "+{count} today",
  "yesterdayTrainedLine": "{n} trained toward their focus",
  "yesterdayRestedLine": "{n} rested",
  "yesterdayPointsLanded": "{n, plural, =0 {no points landed} one {# point landed} other {# points landed}}",
  "yesterdayLine": {
    "injured": "Injured, no training.",
    "pointOne": "Landed a point in {ability}: {from} → {to}.",
    "pointOnePlain": "Landed a point in {ability}.",
    "pointMany": "Landed points in {abilities}.",
    "rest": "Rest day. Fatigue {from} to {to}.",
    "restFresh": "Rest day. Fresh again, fatigue {from} to {to}.",
    "recovery": "Active recovery. Fatigue {from} to {to}.",
    "nearBreakthrough": "Close to a breakthrough in {ability}.",
    "progressing": "Progressing toward {ability}.",
    "trained": "Trained today.",
    "noFocus": "No focus set."
  },
  "individualWeekPlanToggleOpen": "Individual weekly plan",
  "individualWeekPlanToggleClose": "Hide individual plan",
  "individualWeekPlanTitle": "Individual weekly plan",
  "individualWeekPlanIntro": "Set {name}'s own target intensity for each day of the week. This overrides the team's weekly rhythm for this rider only; focus is never touched here.",
  "individualWeekPlanSave": "Save plan",
  "individualWeekPlanRemove": "Remove (follow team rhythm)",
  "individualWeekPlanSaved": "Individual weekly plan saved.",
  "individualWeekPlanRemoved": "Individual weekly plan removed: rider follows the team rhythm again.",
  "individualWeekPlanBadge": "Own plan",
  "individualWeekPlanBadgeTitle": "This rider has their own individual weekly plan, which overrides the team's weekly rhythm.",
  "individualWeekPlanOverviewTitle": "Individual weekly plans",
  "momentLabelToday": "Today's story",
  "momentLabelLatest": "Latest training story",
  "momentBreakthrough_0": "{riderName} breaks through on {ability}: {from} → {to}.",
  "momentBreakthrough_1": "{riderName} finds another gear in {ability}, up to {to} now.",
  "momentBreakthrough_2": "A real step forward for {riderName} today, {ability} climbs to {to}.",
  "momentBreakthrough_3": "{riderName}'s {ability} work pays off: {from} → {to}.",
  "momentInjury_0": "{riderName} picked up a training injury, expected out for about {daysPhrase}.",
  "momentInjury_1": "Tough one for {riderName}: a training injury means about {daysPhrase} on the sidelines.",
  "momentInjury_2": "{riderName} got hurt in a training session, looking at about {daysPhrase} out.",
  "momentInjury_3": "A setback for {riderName}: a training injury means about {daysPhrase} out.",
  "momentNearBreakthrough_0": "{riderName} is closing in on a breakthrough in {ability}, {pct}% of the way there.",
  "momentNearBreakthrough_1": "One more good session and {riderName} bumps {ability} up a level, already {pct}% there.",
  "momentNearBreakthrough_2": "{riderName}'s {ability} is on the edge of the next step, {pct}% through the block.",
  "momentNearBreakthrough_3": "Watch {riderName}: {ability} is nearly ready to tick over, {pct}% logged.",
  "momentPeakForm_0": "{riderName} is riding sharp form right now, primed for the next big day.",
  "momentPeakForm_1": "{riderName} is in peak form today, timing looks good for what's coming.",
  "momentPeakForm_2": "Form is reading strong for {riderName}, this is the shape to race in.",
  "momentPeakForm_3": "{riderName} is flying in training right now, form near its best.",
  "momentSharpDay_0": "{riderName} had a sharp day on the bike, above expectation.",
  "momentSharpDay_1": "A strong session for {riderName} today, output beat the plan.",
  "momentSharpDay_2": "{riderName} answered the day's training well, a sharp one.",
  "momentSharpDay_3": "Good numbers from {riderName} today, a clearly sharp session.",
  "momentQuiet_0": "Quiet day on the training log: {trained} riders out, base miles banked, no headline gains yet.",
  "momentQuiet_1": "Nothing dramatic today, {trained} riders trained and the work goes into the log.",
  "momentQuiet_2": "A steady block for the squad: {trained} on the bike, gains building quietly underneath.",
  "momentQuiet_3": "No standout story today, just {trained} riders putting in the miles.",
  "momentRest_0": "Recovery day across the roster: no sessions logged, legs get the rest instead.",
  "momentRest_1": "Full rest for the squad today, tomorrow's training starts from fresher legs.",
  "momentRest_2": "Quiet at the training base today: everyone's on a rest day.",
  "momentRest_3": "The whole roster took it easy today, recovery over output.",
  "injuryDaysOne": "{days} training day",
  "injuryDaysOther": "{days} training days",
  "injuryAlertLabel": "Training injury today",
  "injuryAlertEntry": "{riderName} (about {daysPhrase})",
  "injuryAlertLine": "Hurt in training today: {list}.",
  "tour": {
    "focus": {
      "title": "Pick what each rider trains",
      "body": "The focus decides which abilities grow fastest. Match it to the rider's type: a focus his type is weak in barely moves, no matter the intensity. Leave it blank and your assistant picks one that fits."
    },
    "runToday": {
      "title": "Train once a day",
      "body": "Press this and the squad trains right away. Skip it and your assistant runs the same session automatically when the day closes. The outcome is the same either way. Hard intensity gains more but leaves riders tired for their next race."
    },
    "runNow": {
      "title": "Run today's training",
      "body": "Run now trains the whole squad today, including riders without a day: they train what your assistant picks for their type. Pressing it gives no bonus. Skip it and your assistant runs the same session automatically."
    },
    "runTodayDayClose": {
      "title": "Run today's training",
      "body": "Press this to run today's training now instead of waiting. It is the same training as the automatic run, with no bonus: the day also runs on its own once the last race is done."
    },
    "runNowDayClose": {
      "title": "Run today's training",
      "body": "Run now trains the whole squad today, including riders without a day: they train what your assistant picks for their type. It is the same training as the automatic run, with no bonus: the day also runs on its own once the last race is done."
    },
    "runStatus": {
      "title": "Train once a day",
      "body": "This line shows today's training: whether it has run, or when it can. When the day can be run, the button that runs it appears right here."
    },
    "nextUp": {
      "title": "Where the training shows up",
      "body": "This bar is how close the rider is to his next whole +1 in the focus ability. Nothing changes on his card until it fills, so read the bar, not the day. That +1 is what he takes into his next race."
    }
  },
  "focusPanel": {
    "title": "Focus for {name}",
    "close": "Close",
    "colFocus": "Focus",
    "colTrains": "Trains",
    "colPerSeason": "Per season",
    "colSignal": "Fit",
    "signalStrong": "strong fit",
    "signalStrongTitle": "This rider's primary or secondary type supports these abilities, so training here goes furthest and fastest.",
    "signalWeak": "little room",
    "signalWeakTitle": "Both of this rider's types work against these abilities, so there is very little room to grow them.",
    "assistantPicks": "Your assistant picks this",
    "noRisk": "No risk of losing progress at any intensity",
    "clear": "Remove focus",
    "cancel": "Cancel",
    "save": "Save focus",
    "note": "A focus develops its own abilities fastest. The rest keep improving more slowly, so a rider grows across the board, just fastest in the direction you choose.",
    "open": "Choose focus",
    "change": "Change"
  },
  "dayPanel": {
    "title": "Training day for {name}",
    "step1": "1 · What kind of day?",
    "step2": "2 · Which session?",
    "colSession": "Session",
    "dayType_rest": "Rest",
    "dayType_recovery": "Active recovery",
    "dayType_skill": "Skill day",
    "dayType_training": "Training",
    "dayTypeNote_rest": "Fatigue drops the most. No growth.",
    "dayTypeNote_recovery": "Fatigue drops a little. A little growth on recovery.",
    "dayTypeNote_skill": "Low load. Craft only, and it builds slowly.",
    "dayTypeNote_training": "Physical abilities, at the level of the session.",
    "noSession_rest": "A rest day has no session. Your rider does not train, and his fatigue comes down faster than on any other day. Whatever session he was on is kept, so one click puts him back on it.",
    "noSession_recovery": "Active recovery has no session. Your rider spins easy: fatigue comes down, though less than on a full rest day, and he gains a little on recovery. It is the only day that lowers fatigue and still develops something.",
    "level_easy": "Easy",
    "level_normal": "Medium",
    "level_hard": "Hard",
    "session_endurance": "Long ride",
    "session_tempo": "Tempo",
    "session_vo2max": "Mixed intervals",
    "session_vo2max_climb": "Climbing intervals",
    "session_vo2max_punch": "Punch intervals",
    "sessionNote_vo2max": "Climbing and punch at an even share.",
    "sessionNote_vo2max_climb": "Punch is not trained. Climbing gains more instead.",
    "sessionNote_vo2max_punch": "Climbing is not trained. Punch gains more instead.",
    "session_threshold": "Threshold",
    "session_sprint": "Sprint",
    "session_cobbled_sectors": "Cobbled Sectors",
    "session_echelon_drills": "Echelon Drills",
    "session_attack_repeats": "Attack Repeats",
    "session_long_climbs": "Long climbs",
    "session_lead_out": "Lead-out",
    "session_itt_short": "Short time trials",
    "session_itt_long": "Long time trials",
    "session_cobbled_classic": "Cobbled classic",
    "sessionNote_cobbled_sectors": "Built for the pavé. Cobbles gains most, durability and positioning come along for the price.",
    "sessionNote_echelon_drills": "Built for crosswinds. Flat gains most, positioning and durability come along for the price.",
    "sessionNote_attack_repeats": "Built for racing aggressively. Aggression gains most, punch and acceleration come along for the price.",
    "sessionNote_long_climbs": "Built for long mountain days. Climbing, tempo and endurance at an even share.",
    "sessionNote_lead_out": "Built for the sprint train. Acceleration, flat and positioning at an even share. Top speed is not trained.",
    "sessionNote_itt_short": "Built for short time trials. Time trial and flat at an even share. Endurance is not trained.",
    "sessionNote_itt_long": "Built for long time trials. Time trial and endurance at an even share. Flat is not trained.",
    "sessionNote_cobbled_classic": "Built for the long cobbled classics. Cobbles and endurance at an even share. Positioning is not trained.",
    "sessionV3_vo2max_climb": "Mountain intervals",
    "sessionV3_vo2max_punch": "VO2max (punch)",
    "sessionNoteV3_threshold": "Time trial is no longer trained here. Tempo gains most, endurance comes along.",
    "sessionNoteV3_sprint": "Top speed gains most, acceleration comes along.",
    "session_technique": "Technique",
    "session_aero": "Aero",
    "session_loebslaere": "Race craft",
    "note": "A session carries its own effort, so you no longer set that separately. Skill days build craft at a fixed, slower rate, whatever the rider is built for.",
    "colDay": "Day",
    "colChangeDay": "Change day",
    "chooseDay": "Choose day",
    "clear": "Remove plan",
    "save": "Save day",
    "done": "Done",
    "pickSession": "Pick a session in step 2 first.",
    "bulkSetDay": "Set day",
    "bulkWholeDay": "Whole day"
  },
  "score": {
    "column": "Score",
    "raceDay": "Race",
    "sparkAria": "Training score, last 7 days: {name}",
    "columnHint": "How good today's session was, 1-99. Race days read 'Race'.",
    "columnHelpAria": "What the training score means: read it in Help",
    "latest": "latest",
    "latestHint": "Today's session has not run yet. This is the latest score.",
    "factor_intensity": "Session",
    "factor_focusMatch": "Focus match",
    "factor_condition": "Form and fatigue",
    "factor_coach": "Coach",
    "factor_facility": "Facilities",
    "factor_potential": "Talent",
    "factor_youth": "Age",
    "factor_noise": "The day"
  },
  "mobile": {
    "today": "Today",
    "raceDayShort": "RD {n}",
    "raceDayState_done": "Done",
    "raceDayState_now": "Now",
    "raceDayState_upcoming": "Later",
    "stripLegend": "Riders with a day set · a race or a session",
    "programTitle": "Program",
    "programEdit": "Edit",
    "programNote": "7 weekdays × {n} race days · a race day is one race or one session",
    "programNoteSingle": "7 weekdays · one session a day",
    "raceShort": "Race",
    "rosterTitle": "The squad today",
    "riderCount": "{n, plural, one {# rider} other {# riders}}",
    "noDay": "Not set",
    "formShort": "F",
    "fatigueShort": "T",
    "countsFor": "Counts for {role}",
    "atCap": "at cap",
    "pace": "Pace · about {n} ability points a week",
    "seasonPoints": "This season: +{n, plural, one {# point} other {# points}}",
    "change": "Change",
    "assistantTitle": "Assistant",
    "assistantCount": "{n, plural, one {# suggestion} other {# suggestions}}",
    "sessionShort_rest": "Rest",
    "sessionShort_recovery": "Recov",
    "sessionShort_endurance": "Long",
    "sessionShort_tempo": "Tempo",
    "sessionShort_vo2max": "VO2",
    "sessionShort_vo2max_climb": "Climb",
    "sessionShort_vo2max_punch": "Punch",
    "sessionShort_threshold": "Thresh",
    "sessionShort_sprint": "Sprint",
    "sessionShort_cobbled_sectors": "Pavé",
    "sessionShort_echelon_drills": "Echelon",
    "sessionShort_attack_repeats": "Attack",
    "sessionShort_long_climbs": "LClimb",
    "sessionShort_lead_out": "Lead",
    "sessionShort_itt_short": "TT S",
    "sessionShort_itt_long": "TT L",
    "sessionShort_cobbled_classic": "Classic",
    "sessionShortV3_vo2max_climb": "Mount",
    "sessionShortV3_vo2max_punch": "Punch",
    "sessionShort_technique": "Tech",
    "sessionShort_aero": "Aero",
    "sessionShort_loebslaere": "Craft",
    "selectRiders": "Select riders",
    "selectDone": "Done",
    "restSelected": "Set to rest",
    "pickHint": "Tap the riders you want to change."
  },
  "programs": {
    "title": "Training programs",
    "intro": "Pick a program and put it on a rider or the whole squad. It is copied into the plan, so you can change any day afterwards.",
    "putOn": "Put on",
    "squad": "Whole squad · {n, plural, one {# rider} other {# riders}}",
    "squadShort": "the whole squad",
    "apply": "Apply program",
    "applying": "Applying…",
    "replacesSquad": "Replaces the week plan of {n, plural, one {# rider} other {# riders}}.",
    "applied": "{name} is now on {target}.",
    "error": "Could not save. Try again.",
    "planTitle": "Plan",
    "basedOn": "Based on {name}",
    "changed": "{n} changed",
    "ownProgram": "Program plan",
    "noProgram": "No program yet",
    "noProgramHint": "This rider has no program yet. Pick one above and put it on him.",
    "cellOverridden": "Changed for this race day",
    "raceNote": "On a race day where the rider races, the session is skipped.",
    "audience_all": "Everyone",
    "audience_allYouth": "Everyone, youth",
    "audience_experienced": "Experienced riders",
    "audience_youth": "Youth",
    "audience_manyRaceDays": "Many race days",
    "audience_youngStars": "Young stars, few races",
    "audience_veterans": "Riders 30+",
    "audience_youthSquads": "Junior, U23, academy",
    "cellsIntro": "Each day has five race-day cells. The weekday's session fills them. Change single cells to choose how many are recovery.",
    "seededHint": "Shows what the rider trains now. Your first change saves it as his own plan.",
    "stageLocked": "Stage",
    "stageLockedTitle": "Locked by the race",
    "listNote": "Tap a program to see its week. It is copied into Plan, so you can change any cell after.",
    "pickTarget": "Pick a rider or group first",
    "pickTargetToPutOn": "Choose who the program is for",
    "fitsType": "Fits {type}",
    "otherPrograms": "Other programs",
    "current": "Current",
    "browse": "Browse programs",
    "closeCatalog": "Close catalog"
  },
  "dailyReceipt": {
    "status": {
      "complete": "Settled",
      "pending": "Awaiting settlement",
      "reconciliation": "Needs reconciliation",
      "recorded": "Recorded activities"
    },
    "note": {
      "trainedNow": "Final race day, fatigue and form at the evening settlement.",
      "complete": "All activities for this date are included. Form and fatigue are settled once for the date.",
      "pending": "This date is not fully settled yet. Final development and condition changes are still pending.",
      "reconciliation": "Some activities need reconciliation. Missing evidence is never shown as zero development.",
      "recorded": "Recorded activities are combined for this date. Older reports may not contain full progress or settlement evidence."
    },
    "riderReceipts": "Rider receipts",
    "trainedNow": "{count, plural, one {Trained now · race day {range}} other {Trained now · race days {range}}}",
    "trainedNowCount": "Trained now",
    "wholePointsSoFar": "Whole ability points so far",
    "waitingForRace": "Waiting for their race",
    "activitiesRecorded": "Race days recorded",
    "wholePoints": "Whole ability points",
    "development": "Daily development",
    "latestPassScore": "Latest session score",
    "averagePassScore": "Average session score",
    "fatigue": "Fatigue",
    "form": "Form",
    "race": "Race",
    "training": "Training",
    "injured": "Injured",
    "noWholePoint": "No whole point recorded",
    "raceDay": "Race day {day}",
    "activity": "Activity {n}",
    "pointContribution": "+{percent}%",
    "progressUnavailable": "Shown after the next training day",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "sortLabel": "Sort riders",
    "sortFirstName": "First name",
    "sortLastName": "Last name",
    "previousSeason": "Previous season",
    "change": "{from} to {to}"
  },
  "forecast": {
    "label": "Fatigue tonight",
    "value": "approx. {value}",
    "band_ok": "Fresh",
    "band_warn": "Tired",
    "band_risk": "Above the injury limit",
    "aria": "Fatigue tonight: approx. {value}. {band}",
    "ariaSettled": "Fatigue tonight: {value}. {band}",
    "teamLabel": "Fatigue tonight, highest"
  },
  "oneTap": {
    "choice_rest": "Rest",
    "choice_recovery": "Recovery",
    "choice_session": "Program",
    "groupAria": "Today for {name}",
    "approx": "~{value}",
    "stageToday": "stage today",
    "locked": "Today is locked after Train now."
  },
  "groups": {
    "section_groups": "Groups",
    "section_riders": "Riders",
    "count": "{n, plural, one {# rider} other {# riders}}",
    "newOption": "+ New group",
    "newTitle": "New group",
    "editTitle": "Edit group",
    "close": "Close",
    "name": "Name",
    "namePlaceholder": "Climbers",
    "startFrom": "Start from",
    "riderType": "Rider type: {type}",
    "pickByHand": "Pick by hand",
    "riders": "Riders ({n})",
    "oneGroupNote": "A rider can be in one group. Moving him removes him from the old one.",
    "movingNote": "{n, plural, one {# rider moves} other {# riders move}} from another group.",
    "create": "Create",
    "save": "Save",
    "delete": "Delete group",
    "error": "Could not save. Try again.",
    "locked": "Today is locked after Train now. Change another day.",
    "edit": "Edit group",
    "followAll": "Follow group ({n})",
    "intro": "One change sets the field for {n, plural, one {# rider} other {all # riders}} in the group. Riders with a stage keep the stage.",
    "seedHint": "Shows the week of the first rider. Your first change sets it for the whole group.",
    "emptyHint": "No riders in this group yet. Edit the group to add riders.",
    "putOnGroup": "Group: {name}",
    "fatigueChip": "Group: {name} · {threshold} · {fallback}",
    "fatigueChipOff": "Group: {name} · no limit",
    "fatigueAdd": "Group",
    "fatigueAddLabel": "Add an exception for a group",
    "fatigueGroupLabel": "Group: {name}",
    "fatigueLadder": "A rider's own exception comes first, then the group's, then the team rule."
  },
  "fatigueRule": {
    "title": "Fatigue limit",
    "intro": "Your own rule. Above the limit a rider runs a lighter session instead. His plan stays as it is, so he goes back to it once he is under the limit.",
    "useLimit": "Use a fatigue limit for the team",
    "aboveLabel": "Above fatigue",
    "insteadLabel": "Run instead",
    "fallback_light": "Same session, light load",
    "fallback_recovery": "Active recovery",
    "fallback_rest": "Rest",
    "afterStage": "Day after a stage: the first slot is active recovery",
    "dateStartNote": "Checked on fatigue at the start of each date, so it does not matter when you log in.",
    "save": "Save rule",
    "saving": "Saving…",
    "saved": "Saved",
    "error": "Could not save. Try again.",
    "exceptions": "Exceptions",
    "exceptionsEmpty": "All riders follow the team rule.",
    "addException": "Add an exception for a rider",
    "mode_team": "Follow team rule",
    "mode_own": "Own limit",
    "mode_off": "No limit",
    "stripTitle": "Last 7 days",
    "stripEmpty": "No rule kicked in on this day.",
    "reason_fatigue": "Fatigue {fatigue} over {threshold}: {fallback}",
    "reason_after_stage": "Day after a stage: {fallback}",
    "overNow": "{count, plural, one {# rider is} other {# riders are}} over the limit now",
    "stripCount": "{count, plural, one {# rider} other {# riders}}",
    "teamRuleAbove": "Team rule: above",
    "teamRuleRun": "run",
    "teamRuleInstead": "instead",
    "add": "Add",
    "chipOwn": "{name} · {threshold} · {fallback}",
    "chipOff": "{name} · no limit",
    "summaryRule": "above {threshold}: {fallback}",
    "summaryAfterStage": "day after a stage: active recovery",
    "summaryExceptionsOnly": "exceptions only",
    "summaryOff": "not set",
    "summaryToday": "{count, plural, one {# rider} other {# riders}} today",
    "summaryEdit": "Edit",
    "summarySet": "Set up"
  },
  "subtabs": {
    "label": "Program views",
    "plan": "Plan",
    "programs": "Programs",
    "limit": "Fatigue limit",
    "limitShort": "Limit"
  }
}
